import { render, staticRenderFns } from "./menu-entries.vue?vue&type=template&id=6a5ec5d8&scoped=true&"
import script from "./menu-entries.ts?vue&type=script&lang=ts&"
export * from "./menu-entries.ts?vue&type=script&lang=ts&"
import style0 from "./menu-entries.scss?vue&type=style&index=0&id=6a5ec5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ec5d8",
  null
  
)

export default component.exports